// ─── ModernScene ───────────────────────────────────────────────
import modernscene1  from "../assets/img/modernscene.png";
import modernscene2  from "../assets/img/modernscene2.png";
import modernscene3  from "../assets/img/modernscene3.png";
import modernscene4  from "../assets/img/modernscene4.png";

// ─── The Wild Resort ───────────────────────────────────────────
import wildResort1   from "../assets/img/wild-resort.png";
import wildResort2   from "../assets/img/wild-resort2.png";
import wildResort3   from "../assets/img/wild-resort3.png";
import wildResort4   from "../assets/img/wild-resort4.png";

// ─── MovieVerse ────────────────────────────────────────────────
import movieverse    from "../assets/img/movieverse.png";

// ─── Task Management Platform ──────────────────────────────────
import taskApp1      from "../assets/img/task-app-1.png";
import taskApp2      from "../assets/img/task-app-2.png";
import taskApp3      from "../assets/img/task-app-3.png";
import taskApp4      from "../assets/img/task-app-4.png";
import taskApp5      from "../assets/img/task-app-5.png";
import taskApp6      from "../assets/img/task-app-6.png";
import taskApp7      from "../assets/img/task-app-7.png";
import taskApp8      from "../assets/img/task-app-8.png";
import taskApp9      from "../assets/img/task-app-9.png";
import taskApp10     from "../assets/img/task-app-10.png";
import taskApp11     from "../assets/img/task-app-11.png";

// ─── Video Streaming Platform ──────────────────────────────────
import videoStream1  from "../assets/img/video-stream1.jfif";
import videoStream2  from "../assets/img/video-stream2.jfif";
import videoStream3  from "../assets/img/video-stream3.jfif";
import videoStream4  from "../assets/img/video-stream4.jfif";
import videoStream5  from "../assets/img/video-stream5.jfif";
import videoStream6  from "../assets/img/video-stream6.jfif";
import videoStream7  from "../assets/img/video-stream7.jfif";
import videoStream8  from "../assets/img/video-stream8.jfif";
import videoStream9  from "../assets/img/video-stream9.jfif";
import videoStream10 from "../assets/img/video-stream10.jfif";
import videoStream11 from "../assets/img/video-stream11.jfif";
import videoStream12 from "../assets/img/video-stream12.jfif";
import videoStream13 from "../assets/img/video-stream13.jfif";

// ─── Serverless Chat System ────────────────────────────────────
import chatApp1      from "../assets/img/chat-app1.jfif";
import chatApp2      from "../assets/img/chat-app2.jfif";
import chatApp3      from "../assets/img/chat-app3.jfif";
import chatApp4      from "../assets/img/chat-app4.jfif";
import chatApp5      from "../assets/img/chat-app5.jfif";
import chatApp6      from "../assets/img/chat-app6.jfif";
import chatApp7      from "../assets/img/chat-app7.jfif";
import chatApp8      from "../assets/img/chat-app8.jfif";
import chatApp9      from "../assets/img/chat-app9.jfif";
import chatApp10     from "../assets/img/chat-app10.jfif";
import chatApp11     from "../assets/img/chat-app11.jfif";

// ─── Sonic Steel ───────────────────────────────────────────────
import sonic         from "../assets/img/sonic.png";

// ─── Student Grievance System ──────────────────────────────────
import sghs1         from "../assets/img/sghs.png";
import sghs2         from "../assets/img/sghs2.png";
import sghs3         from "../assets/img/sghs3.png";
import sghs4         from "../assets/img/sghs4.png";
import sghs5         from "../assets/img/sghs5.png";
import sghs6         from "../assets/img/sghs6.png";

// ─── eBookNest ─────────────────────────────────────────────────
import ebook         from "../assets/img/ebook.png";

// ─── Taskify ───────────────────────────────────────────────────
import taskify       from "../assets/img/taskify.png";

// ─── Finder ────────────────────────────────────────────────────
import finder        from "../assets/img/finder.png";

// ─────────────────────────────────────────────────────────────────
// TAB 1 – Featured
// ─────────────────────────────────────────────────────────────────
export const tabOneProjects = [
  {
    title: "ModernScene",
    overview:
      "A modern full-stack web application built with React, TypeScript, Node.js, and MySQL designed for fine art and wedding photographers. It provides clients with an immersive visual browsing experience and equips studio owners with a custom, secure administrative dashboard for effortless content curation.",
    highlights: [
      {
        label: "Automated Asset Optimization",
        text: "Implemented a backend processing pipeline using Sharp to automatically resize and compress high-resolution image uploads, reducing load times while preserving visual sharpness.",
      },
      {
        label: "Interactive CMS & DND Reordering",
        text: "Built drag-and-drop bulk file uploads and gallery sequence reordering with DND Kit.",
      },
      {
        label: "Modern UI/UX",
        text: "Crafted accessible, responsive design components using Radix UI, Tailwind CSS, and Motion for smooth layout transitions and mobile-first navigation.",
      },
      {
        label: "Full-Stack Security",
        text: "Protected the administrative dashboard with JWTs in HTTP-only cookies, Bcrypt hashing, strict CORS policies, and automated database migrations.",
      },
    ],
    techStack: ["ReactJs", "TypeScript", "Vite", "NodeJs", "ExpressJs", "MySQL", "Tailwind CSS", "GitHub Actions"],
    images: [modernscene1, modernscene2, modernscene3, modernscene4],
    demo: "https://www.modernscene.lk",
    code: "https://github.com/AbstractLK/modernscene_web",
  },
  {
    title: "The Wild Resort (Customer Reservation Platform)",
    overview:
      "A modern, full-stack hospitality booking platform designed for a luxury wilderness retreat. Built on the Next.js 15 App Router, the application delivers an effortless guest experience—from exploring cabins and checking real-time date availability to booking stays and managing reservations through a personalized guest dashboard.",
    highlights: [
      {
        label: "Interactive Reservation Engine",
        text: "Real-time calendar date-range selector featuring instant price calculation, length-of-stay validation, and automatic conflict detection against existing bookings.",
      },
      {
        label: "Serverless Cloud MySQL Backend",
        text: "Built with a resilient, TLS-encrypted connection pool (mysql2) connecting to a distributed, cloud-native TiDB (MySQL 8.0) database.",
      },
      {
        label: "Next.js 15 & Server Actions",
        text: "Leveraged React Server Components (RSC) for lightning-fast initial page loads and Server Actions for clean, zero-boilerplate data mutations and instant cache revalidation.",
      },
      {
        label: "Protected Guest Portal",
        text: "Seamless Google OAuth authentication powered by NextAuth.js v5 (Auth.js) and Edge Middleware, allowing guests to view, edit, or cancel reservations and update profile details.",
      },
      {
        label: "Responsive Dashboard UI",
        text: "Crafted with Tailwind CSS, featuring a sticky viewport-aware sidebar navigation, animated mobile menus, and smooth layout adaptations across devices.",
      },
    ],
    techStack: ["Next.js 15", "React 18", "Tailwind CSS", "MySQL (TiDB)", "Node.js", "NextAuth.js v5", "Google OAuth"],
    images: [wildResort1, wildResort2, wildResort3, wildResort4],
    demo: "https://wild-resort-website.vercel.app",
    code: "https://github.com/AbstractLK/wild-resort-website",
  },
  {
    title: "MovieVerse",
    overview: "A responsive movie discovery web app powered by the TMDB REST API. Built as a sleek single-page application (SPA), it enables users to seamlessly explore current releases, top-rated classics, upcoming films, and search for any movie with deep-dive details.",
    highlights: [
      {
        label: "Curated Feeds & Search",
        text: "Real-time browsing across Now Playing, Popular, Top Rated, and Upcoming categories with instant query-based search.",
      },
      {
        label: "Comprehensive Metadata",
        text: "Deep-dive details pages showcasing ratings, vote counts, runtime, genre badges, budget/revenue metrics, and direct IMDb links.",
      },
      {
        label: "Custom React Hooks",
        text: "Built with reusable custom hooks (useFetch for clean API data retrieval and usePageTitle for dynamic document titles).",
      },
      {
        label: "Adaptive UX & Theming",
        text: "Full dark/light mode toggle, automated route-change scroll resets (ScrollToTop), custom 404 error handling, and poster fallbacks.",
      }
    ],
    techStack: ["React 19", "React Router v7", "Tailwind CSS", "TMDB API", "JavaScript (ES6+)", "REST API"],
    images: [movieverse],
    demo: "https://movieverse-abstractnode.vercel.app",
    code: "https://github.com/AbstractLK/MovieVerse",
  },
];

// ─────────────────────────────────────────────────────────────────
// TAB 2 – DevOps
// ─────────────────────────────────────────────────────────────────
export const tabTwoProjects = [
  {
    title: "Cloud-Native DevOps & GitOps - Task Management Platform",
    overview:
      "An enterprise-grade, cloud-native microservices platform demonstrating a complete DevSecOps lifecycle and infrastructure evolution on AWS. The project features a containerized task management system backed by automated CI/CD pipelines, GitOps-driven Kubernetes delivery, zero-trust secrets management, and full-stack observability.",
    highlights: [
      {
        label: "Infrastructure Evolution (IaC)",
        text: "Modularly provisioned multi-tier AWS environments using Terraform, demonstrating an architectural progression from single EC2 instances to ECS Fargate, culminating in a production-ready Amazon EKS cluster with private/public subnets and NAT routing.",
      },
      {
        label: "Automated DevSecOps Pipeline",
        text: "Configured a Jenkins pipeline with monorepo changeset detection, automated SCA audits (npm audit), and container vulnerability scanning with Trivy before pushing images to Docker Hub.",
      },
      {
        label: "Declarative GitOps (ArgoCD)",
        text: "Implemented an \"App of Apps\" pattern with Helm charts using staged sync waves to automatically orchestrate resource dependencies (Ingress, IRSA, secrets, and microservices).",
      },
      {
        label: "Zero-Trust Secrets Management",
        text: "Eliminated hardcoded credentials via External Secrets Operator (ESO) combined with AWS SSM Parameter Store and IAM Roles for Service Accounts (IRSA) for dynamic in-cluster secret synchronization.",
      },
      {
        label: "Observability & Traffic Routing",
        text: "Configured an NGINX Ingress Controller tied to an AWS Network Load Balancer (NLB) and deployed an optimized Prometheus & Grafana stack for cluster health and application metrics.",
      },
    ],
    techStack: ["ReactJs", "NodeJs/Express", "MongoDB", 'Tailwind CSS', "AWS", "EKS", "Kubernetes", "Docker", "GitOps", "Jenkins", "Helm", "Terraform", "ArgoCD", "Trivy", "Prometheus", "Grafana"],
    images: [taskApp1, taskApp2, taskApp3, taskApp4, taskApp5, taskApp6, taskApp7, taskApp8, taskApp9, taskApp10, taskApp11],
    demo: "",
    code: "https://github.com/AbstractLK/task-management-app-dev.git",
  },
  {
    title: "DevOps-Focused Video Streaming Platform on AWS EKS (GitOps + Kubernetes)",
    overview:
      "A production-grade, cloud-native video streaming microservices platform deployed on AWS. Engineered for end-to-end media delivery, it handles secure browser uploads via presigned S3 URLs, asynchronous FFmpeg transcoding via Amazon SQS, and low-latency adaptive HLS playback through Amazon CloudFront—fully orchestrated using Terraform and GitOps.",
    highlights: [
      {
        label: "Event-Driven Media Pipeline",
        text: "Decoupled asynchronous video processing architecture using Amazon SQS (with DLQ) and FFmpeg to transcode raw uploads into adaptive HLS streams delivered globally via CloudFront.",
      },
      {
        label: "GitOps & Automated CI/CD",
        text: "Fully automated pipeline utilizing Jenkins for syntax testing, Trivy container security scanning, and ECR publishing, paired with Argo CD for declarative GitOps synchronization to Amazon EKS.",
      },
      {
        label: "Production-Grade IaC & Security",
        text: "Modular AWS infrastructure (VPC, EKS, S3, CloudFront, SQS, ECR) provisioned via Terraform with strict least-privilege IAM and IRSA (IAM Roles for Service Accounts).",
      },
      {
        label: "Full-Stack Observability",
        text: "Built-in telemetry across all services with custom Prometheus metric endpoints, Grafana monitoring dashboards, Alertmanager, and log aggregation via Fluent Bit to Amazon CloudWatch.",
      },
    ],
    techStack: ["ReactJs", "NodeJs", "AWS", "EKS", "Kubernetes", "Docker", "GitOps", "Jenkins", "Helm", "Terraform", "ArgoCD", "Trivy", "Prometheus", "Grafana"],
    images: [videoStream1, videoStream2, videoStream3, videoStream4, videoStream5, videoStream6, videoStream7, videoStream8, videoStream9, videoStream10, videoStream11, videoStream12, videoStream13],
    demo: "",
    code: "https://github.com/AbstractLK/video-streaming-platform.git",
  },
  {
    title: "Serverless Real-Time Chat System on AWS",
    overview:
      "A production-grade, 100% serverless real-time chat platform engineered on AWS. Designed to scale to zero with zero server maintenance, it delivers low-latency 1-on-1 and group messaging with live presence, typing indicators, read receipts, and unread counters across an event-driven cloud architecture.",
    highlights: [
      {
        label: "Real-Time Bidirectional Streaming",
        text: "Powered by API Gateway WebSocket API and AWS Lambda for sub-second messaging, connection lifecycle management, and live activity broadcasts.",
      },
      {
        label: "Asynchronous Event-Driven Pipeline",
        text: "Decoupled conversation summaries and unread badge counters via Amazon SQS with an automated Dead Letter Queue (DLQ) and consumer Lambdas.",
      },
      {
        label: "Enterprise Security & Auth",
        text: "Secure token-based authentication with Amazon Cognito (JWT), custom Lambda authorizers, and strict least-privilege IAM roles.",
      },
      {
        label: "Automated GitOps & IaC",
        text: "Fully provisioned with modular Terraform across multi-environments; automated zero-secret deployments via GitHub Actions and AWS OIDC federation.",
      },
      {
        label: "Edge Delivery & Cost Optimization",
        text: "Single-Page App hosted on S3 and distributed globally via CloudFront (OAC), paired with DynamoDB on-demand billing to eliminate idle costs.",
      },
    ],
    techStack: ["React 19", "NodeJs", "AWS Lambda", "DynamoDB", "API Gateway", "Amazon SQS", "WebSockets", "S3", "CloudFront", "Cognito", "CloudWatch", "Terraform", "GitHub Actions"],
    images: [chatApp1, chatApp2, chatApp3, chatApp4, chatApp5, chatApp6, chatApp7, chatApp8, chatApp9, chatApp10, chatApp11],
    demo: "",
    code: "https://github.com/AbstractLK/serverless-chat-system.git",
  },
];

// ─────────────────────────────────────────────────────────────────
// TAB 3 – Production
// ─────────────────────────────────────────────────────────────────
export const tabThreeProjects = [
  {
    title: "Sonic Steel Industries Website",
    description: "Business website highlighting services, company profile, and contact pathways for an industrial manufacturing brand.",
    techStack: ["PHP", "MySQL", "CSS", "Ajax"],
    images: [sonic],
    demo: "https://www.sonicsteel.lk",
    code: "https://github.com/AbstractLK/sonic",
  },
  {
    title: "Student Grievance System",
    description: (
      <>
        Designed and developed a full-stack web platform to streamline and digitize grievance management processes for university students and administrators.<br /><br />
        Implemented the solution using the MEVN stack (MongoDB, Express.js, Vue.js, Node.js), ensuring robust data handling and efficient API performance.
      </>
    ),
    techStack: ["VueJs", "ExpressJs", "NodeJs", "MongoDB"],
    images: [sghs1, sghs2, sghs3, sghs4, sghs5, sghs6],
    demo: "https://student-grievance-system.vercel.app",
    code: "https://github.com/AbstractLK/Student-Grievance-System",
  },
  {
    title: "eBookNest",
    description: "Digital book browsing platform focused on intuitive navigation, content grouping, and responsive UI behavior.",
    techStack: ["ReactJs", "JavaScript", "CSS"],
    images: [ebook],
    demo: "https://ebooknest.vercel.app/",
    code: "https://github.com/AbstractLK/eBookNest",
  },
];

// ─────────────────────────────────────────────────────────────────
// TAB 4 – Experiments
// ─────────────────────────────────────────────────────────────────
export const tabFourProjects = [
  {
    title: "Taskify",
    description: "Task management app for creating, tracking, and updating daily work with a focused and lightweight interface.",
    techStack: ["ReactJs", "JavaScript", "Local Storage"],
    images: [taskify],
    demo: "https://taskify-abstractnode.vercel.app",
    code: "https://github.com/AbstractLK/Taskify",
  },
  {
    title: "Finder",
    description: "Utility-style interface for quick lookups and structured results built with a compact, mobile-friendly workflow.",
    techStack: ["VueJs", "JavaScript", "CSS"],
    images: [finder],
    demo: "https://finder-abstractnode.vercel.app",
    code: "https://github.com/AbstractLK/Finder",
  },
];

